import React from 'react';
import { Link } from 'react-router-dom';

import { startConversation } from '../../api/conversation';

import { useApp } from '../../context/AppContext';

import { sendGTMEvent } from '../../utils/analytics';
import { GA4_KEY, ROUTES } from '../../utils/constants';
import { formatBotUrl } from '../../utils/common';

import styles from './ProfileActions.module.css';


const ProfileActions = () => {
  const { appDescription, appSubscriptionInfo } = useApp();
  const { bot_url } = appDescription;
  const openAIChat = () => {
    const tg = window.Telegram?.WebApp;
    const isTdesktop = tg.platform === 'tdesktop';

    window.Telegram.WebApp.setHeaderColor('#1D2733');
    window.Telegram.WebApp.HapticFeedback.impactOccurred('light');
    startConversation('Привет!');
    if (!tg?.initDataUnsafe?.query_id) {
      tg.openTelegramLink(formatBotUrl(bot_url));
    }
    document.querySelector('.App').classList.add('fadeOut');
    sendGTMEvent(GA4_KEY.open_ai_chat);
    if (isTdesktop) {
      setTimeout(() => {
        tg.close();
      }, 350);
    } else {
      tg.close();
    }
  };

  return (
    <div className={styles.profileActionsContainer}>
      <div className={styles.profileActions}>
        {appDescription.communities?.length > 0 && (
          <Link
            to={ROUTES.communities}
            className={styles.profileButton}
            onClick={() => {
              sendGTMEvent(GA4_KEY.open_communities);
              window.Telegram.WebApp.HapticFeedback.impactOccurred('light');
            }}
          >
            <i className='fas fa-comment-dollar'></i>{appDescription?.communities_button || 'Сообщества'}
          </Link>
        )}
        {appDescription?.chat_button?.isActive && (
          <button
            className={styles.profileButton}
            onClick={() => {
              openAIChat();
            }}
          >
            <i className='fas fa-envelope'></i>
            {appDescription.chat_button.text}
          </button>
        )}
      </div>
      {appDescription?.subscription_button &&
        appSubscriptionInfo?.subscribeText && (
          <Link
            to={ROUTES.subscription}
            state={{ from: ROUTES.home }}
            className={styles.profileButton}
            onClick={() => {
              sendGTMEvent(GA4_KEY.open_subscription);
              window.Telegram.WebApp.HapticFeedback.impactOccurred('light');
            }}
          >
            Подпискa
          </Link>
        )}
    </div>
  );
};

export default ProfileActions;
